var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatIntro = function SvgChatIntro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 731 683"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FBFF",
    d: "M627.982 55.63c-33.312-27.115-74.33-41.466-116.934-48.919-33.626-5.896-67.925-7.482-102-6.39C253.79 5.5 206.337 83.136 168.387 92.623 63.724 118.798 10.36 215.754 2.114 316.75a501 501 0 0 0-.613 8.171c-3.757 56.372-1.736 114.27 21.025 166.886 19.364 44.7 54.726 77.936 97.525 100.263 99.2 51.763 201.843 34.509 261.373 9.488s52.615-37.95 132.841-15.518 150.979-29.271 176.852-89.714c25.874-60.442 62.134-192.46 20.712-308.81-15.055-42.276-35.946-84.341-67.76-117.099a186 186 0 0 0-16.087-14.785Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M494.691 654.652H677.44m-627.559 0h432.105"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#001550",
    stroke: "#001550",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M244.213 17.83h-54.622v4.938h-69.929A43.12 43.12 0 0 0 89.16 35.412a43.1 43.1 0 0 0-12.612 30.515v231.488a43.116 43.116 0 0 0 43.114 43.113h470.474a43.11 43.11 0 0 0 43.098-43.113V65.926a43.113 43.113 0 0 0-43.098-43.113H290.842v-4.938h-32.353v4.938h-14.276z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#001550",
    stroke: "#001550",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M82.49 73.424v216.434c0 25.224 20.447 45.672 45.671 45.672h453.46c25.224 0 45.672-20.448 45.672-45.672V73.424c0-25.224-20.448-45.672-45.672-45.672h-453.46c-25.224 0-45.672 20.448-45.672 45.672Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M86.41 79.395v85.478l.314.09c9.428 2.529 15.564 8.35 15.564 14.8v3.711c0 6.45-6.136 12.271-15.564 14.8l-.314.09v85.478c0 23.809 19.978 43.098 44.64 43.098h445.169c24.662 0 44.639-19.289 44.639-43.098V79.395c0-23.81-19.977-43.113-44.639-43.113H131.05c-24.722.03-44.64 19.334-44.64 43.113"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M541.905 233.591h62.373m-286.559 0h214.234m-433.9 0h203.4M588.31 206.19l19.275 18.811m-314.558-90.447 107.851 77.278L503.61 123.54l76.44 74.599M98.486 213.807l156.187-106.713 30.827 22.088m215.73-37.651h39.926s1.063-13.723-12.675-16.895c-10.715-2.47-24.018 6.42-33.027-.988l-.225-.194c-3.965-3.427-6.404-8.23-9.592-12.391a37.1 37.1 0 0 0-27.251-14.59c-10.639-.42-21.534 4.893-27.041 14.006-1.496 2.485-2.798 5.388-5.417 6.615-4.953 2.334-9.936-2.724-14.965-4.983-15.862-7.184-17.673 9.472-25.679 16.97s-19.753-3.532-27.999 1.96a22.74 22.74 0 0 0-8.455 10.565h140.593M194.529 79.844a18.9 18.9 0 0 0-8.35-2.395 16.86 16.86 0 0 0-14.965 7.722 8.4 8.4 0 0 1-2.992 3.651c-2.739 1.272-5.478-1.496-8.216-2.753-8.739-3.966-9.742 5.223-14.157 9.353s-10.879-1.946-15.413 1.077a12.55 12.55 0 0 0-4.654 5.822h105.92s.583-7.573-6.974-9.308c-5.911-1.362-13.244 3.531-18.197-.554a.4.4 0 0 1-.12-.105c-2.184-1.885-3.531-4.49-5.297-6.824",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M569.171 290.576H138.113v11.014h431.058z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBD14",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M400.534 290.576H138.113v11.014h262.421z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M411.338 296.083a7.21 7.21 0 0 0-4.456-6.665 7.216 7.216 0 0 0-9.833 5.267 7.213 7.213 0 0 0 7.091 8.611 7.2 7.2 0 0 0 5.095-2.113 7.2 7.2 0 0 0 2.103-5.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCCDFF",
    d: "M88.475 186.572a4.04 4.04 0 1 0 0-8.081 4.04 4.04 0 0 0 0 8.081"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m494.602 165.891-36.948-21.325v42.664zm17.179-23.256h-9.967v46.526h9.967zm-299.114 23.256 36.963-21.325v42.664zm-17.164 23.27h9.966v-46.526h-9.966z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBD14",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M353.634 201.327c19.39 0 35.108-15.718 35.108-35.107s-15.718-35.107-35.108-35.107-35.107 15.718-35.107 35.107 15.718 35.107 35.107 35.107"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M349.355 146.766h-15.668v38.908h15.668zm24.242 0h-15.668v38.908h15.668zm-114.494 90.895s10.191 5.552 11.118 10.176c.928 4.624.449 10.655 1.841 12.047 1.392 1.391 7.647.464 7.183 4.863a17.4 17.4 0 0 1-2.08 6.944s-.239 6.48-.703 11.792 0 7.482-2.993 8.799-13.663.24-15.279.464-4.624-7.407-6.704-23.839 2.993-32.862 7.617-31.246M154.08 440.343l-9.263 12.974s-12.495.464-16.461 1.152c-3.966.689-4.624 2.32-4.624 4.4s-.464 6.704-.464 8.799a4.696 4.696 0 0 0 4.4 4.16c2.304.225 4.399.689 5.552-.224a15.1 15.1 0 0 0 2.544-3.711s4.175 1.855 8.978-2.08a74 74 0 0 0 8.874-7.812c1.392-1.616 11.583-10.655 11.583-10.655z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M135.794 467.893s-5.552 1.152-6.944-.689"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M211.65 433.743s-10.146 27.475-9.159 38.594 1.961 26.832 2.29 40.569.643 40.555.643 40.555-4.25 14.396-5.222 21.923-.659 68.239-.659 68.239-4.579 11.777-7.482 16.027-7.198 7.482-10.475 10.475c-3.278 2.993-1.976 7.198 3.92 8.171s12.75.329 15.698-1.302 9.159-2.993 11.448-8.186c2.29-5.192 1.317-22.896 1.317-22.896s13.468-51.239 15.698-65.949 5.552-37.292 5.881-39.911 13.468-60.188 13.468-60.188l6.54-.658 5.881 26.832 7.482 50.041s-1.96 20.278.33 34.344 3.92 68.568 3.92 68.568-2.618 17.345-1.631 19.963c.988 2.619 5.552 2.993 12.421 2.619a38.1 38.1 0 0 0 16.356-5.237 5.36 5.36 0 0 0 2.29-7.198c-1.302-2.993-4.579-5.567-6.54-8.83-1.96-3.262-3.92-4.908-4.579-7.856s5.567-58.362 4.579-70.199c-.987-11.837-1.302-27.475-1.302-27.475s7.483-26.832 7.842-54.636 3.606-31.726-3.262-49.713-10.805-24.542-10.805-24.542l-75.227 1.96z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#001550",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M296.035 582.208c-.973-11.777-1.302-27.475-1.302-27.475s7.482-26.832 7.842-54.636 3.606-31.725-3.263-49.713-10.804-24.542-10.804-24.542l-75.228 1.96-1.631 5.896s-10.146 27.475-9.158 38.594c.987 11.119 1.96 26.832 2.289 40.569s.644 40.555.644 40.555-4.25 14.396-5.223 21.923c-.613 4.669-.718 37.995-.718 52.541a18.07 18.07 0 0 1 18.811 1.601c3.95-12.046 10.071-41.362 11.343-49.563 2.289-14.725 5.552-37.292 5.881-39.911s13.468-60.188 13.468-60.188l6.54-.658 5.881 26.832 7.482 50.042s-1.96 20.277.329 34.343c1.407 8.62 2.559 40.719 3.248 53.993a21.5 21.5 0 0 0 19.768-2.23c1.496-13.992 4.504-51.433 3.801-59.933"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBD14",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M296.035 660.308c-.988-1.661-1.99-2.903-2.813-4.115-.359.868-.823 2.005-1.497 3.457a4.58 4.58 0 0 1-4.908 3.277s-5.552-4.908-9.488-5.238c-3.935-.329-4.25 1.302-4.25 1.302s-2.618 17.344-1.631 19.963c.988 2.619 5.552 2.993 12.421 2.619a38.1 38.1 0 0 0 16.356-5.238 5.357 5.357 0 0 0 2.29-7.198c-1.242-2.948-4.519-5.566-6.48-8.829m-90.282-10.146a28.4 28.4 0 0 0-7.482 7.483 26.5 26.5 0 0 0-1.706-6.839 61 61 0 0 1-4.489 8.799c-2.993 4.25-7.199 7.482-10.476 10.475s-1.975 7.198 3.921 8.171 12.75.329 15.698-1.302 9.158-2.993 11.448-8.186c1.661-3.786 1.601-14.111 1.496-19.454l-.793.225s-3.038-2.32-7.617.628"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M205.753 665.86c-7.482 1.317-11.777 5.896-17.658 8.186a228 228 0 0 0-6.57 2.679 8.8 8.8 0 0 0 3.951 1.496c5.881.988 12.75.329 15.698-1.302s9.158-2.993 11.448-8.185c-.045.074.658-4.221-6.869-2.874"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#10B981",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M210.721 430.705s-2.08 4.4 0 6.944 22.223 10.64 46.526 6.24c24.302-4.399 27.31-5.552 31.425-11.807s2.32-10.176 1.153-13.184c-1.168-3.008 13.198 9.263-26.847 12.496-40.045 3.232-50.401-5.552-50.401-5.552z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M339.403 245.607s1.765-16.461 1.765-17.254a56 56 0 0 0-4.055-8.62c-1.496-2.798-2.035-5.327-3.547-8.619-1.511-3.292-7.362-2.799-4.489-5.328s4.489-2.289 6.584-1.017c2.096 1.272 3.562 2.993 5.582 2.02s5.582-16.985 6.091-19.02 4.055-2.529 4.564 0-1.257 14.965-1.257 14.965 3.801-2.021 5.328-1.018a5.6 5.6 0 0 1 2.02 2.798s2.993 1.497 3.292 3.293l.254 1.78s2.036 2.993 1.781 5.073a48.3 48.3 0 0 1-3.546 11.164c-2.036 4.564-5.328 10.909-6.091 12.93a94 94 0 0 0-1.781 10.909z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#10B981",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M261.646 300.393s12.047 7.632 13.663 6.704 10.64-7.168 17.584-8.979 8.799-2.544 10.475-4.175 22.926-18.975 24.078-20.591 12.735-33.326 12.735-33.326 5.776-.24 8.335.912c1.7.837 3.26 1.933 4.624 3.248 0 0-3.935 38.19-4.624 40.509s-9.502 11.568-14.351 17.12c-4.848 5.552-40.749 31.425-42.365 34.493s-9.727 31.246-11.104 39.582c-1.376 8.335 9.712 34.029 9.952 38.429.239 4.4 1.616 10.176-1.856 14.112s-11.971 8.799-44.445 10.655c-32.473 1.855-34.942-7.647-34.942-11.119s2.544-18.287 1.616-28.702a148 148 0 0 0-2.544-17.584s-7.871 19.454-9.952 22.911-10.475 20.591-15.742 26.622-14.292 20.517-20.083 19.828c-5.791-.688-8.979-5.088-8.979-8.096a32.9 32.9 0 0 1 1.616-7.871s20.951-37.666 22.851-41.602c1.901-3.935 7.647-24.063 9.264-32.398s1.152-26.847 4.399-31.95 29.63-16.192 36.334-20.367 23.51-9.757 33.461-8.365"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m199.229 361.464 9.188 20.172-12.541-16.446m84.626-17.898 11.238-11.029-13.842 22.971m-19.02 36.903s-19.753 26.098-35.421 32.802m22.042-25.35s-16.461 17.524-19.753 20.143"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#001550",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M226.045 238.35a32.5 32.5 0 0 0-11.343 14.126c-3.232 8.799-1.84 20.592-2.08 21.759-.239 1.167-24.302 2.08-26.158 10.879s5.327 15.279 6.48 19.454c1.152 4.175-14.815 6.944-17.12 17.823-2.304 10.879 24.527 11.807 23.375 18.511-1.152 6.705-3.696 5.792-2.993 12.735.703 6.944 9.263 10.191 19.454 13.469s9.727 5.551 15.967.463 6.719-9.263 7.872-14.111 2.544-1.167 10.475-7.647 9.951-16.461 9.263-21.055-.224 1.152 5.552-7.183c5.776-8.336 3.247-12.272-.464-20.143s-5.312-10.879-4.848-16.192c.463-5.312 6.943-22.686 3.696-29.166-3.248-6.48-5.328-5.986-3.696-10.191 1.631-4.205 5.551-5.088.688-10.64s-12.735-5.791-16.207-3.711-1.392 2.544-7.168 4.175a27.55 27.55 0 0 0-10.745 6.645"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BAAFF",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M272.062 275.507c0 6.839-4.19 12.376-9.368 12.376s-9.383-5.537-9.383-12.376 4.205-12.391 9.383-12.391 9.368 5.552 9.368 12.391"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M272.571 275.507c0 5.178-3.188 9.383-7.109 9.383s-7.093-4.205-7.093-9.383 3.173-9.383 7.093-9.383 7.109 4.205 7.109 9.383"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BAAFF",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M265.896 256.502a36.36 36.36 0 0 0-9.547-18.871c-5.312-5.327-14.172-7.647-22.552-5.986-6.435 1.317-9.637 4.101-11.493 8.725-.269.688-1.78 2.035-1.496 2.664-.703-1.692 9.293-6.465 10.385-6.824a20.77 20.77 0 0 1 21.43 5.118 31.43 31.43 0 0 1 8.051 15.862 2.65 2.65 0 0 0 2.619 2.275h.374a2.665 2.665 0 0 0 2.229-2.963"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#001550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M264.953 274.025a4.67 4.67 0 0 1-4.609-4.085 98.5 98.5 0 0 0-2.559-12.705 4.662 4.662 0 0 1 6.781-5.308 4.66 4.66 0 0 1 2.198 2.809c1.257 4.62 2.202 9.32 2.829 14.067a4.65 4.65 0 0 1-.947 3.427 4.62 4.62 0 0 1-3.094 1.75 4 4 0 0 1-.599.045"
  })));
};
export default SvgChatIntro;